// const localUrl =
//   "https://xcelengapp002-c8d0f4b3hxa6hjfa.centralindia-01.azurewebsites.net/";
// const redirect_url =
//   "https://xcelengapp001-dnh0c9gqfph6g7fm.centralindia-01.azurewebsites.net/dashboard";
//const redirect_url = "https://xcelenergywfm.cyient.com/dashboard";
import axios from "axios";
//Azure hosting enable start code
const localUrl = "/prod";
const react_loging = "azure";
const redirect_url = "/dashboard";
//Azure hosting enable end code
//Test server enable start code
//const localUrl = "http://172.16.32.149:4032";
//const redirect_url = "http://172.16.5.121:93/dashboard";
//tEST server enable END code
//Localhost enable start code
// const localUrl = "http://localhost:4032";
// const react_loging = "local";
// const redirect_url = "http://localhost:3000/dashboard";
//Localhost enable end code

//const redirect_url = "https://pms.cyient.com/xcelenergy/dashboard";
// const localUrl = "https://xcelenergyapi.azure-api.net/xcelenergy002";
//const redirect_url = "https://pms.cyient.com/xcelenergy/dashboard";

let _timesheetTime = (() => {
  try {
    const v = Number(localStorage.getItem("Timesheettime_cache"));
    return v === 9 || v === 12 ? v : 12;
  } catch {
    return 12;
  }
})();
const config = {
  Timesheettime: 12,
  get Timesheettime() {
    return _timesheetTime;
  },
  set Timesheettime(v) {
    const n = Number(v);
    if (n === 9 || n === 12) {
      _timesheetTime = n;
      try {
        localStorage.setItem("Timesheettime_cache", String(n)); // cache only, DB is the source of truth
      } catch {
        // storage blocked; in-memory value still works
      }
    }
  },
  getTimesheetTime: { url: `${localUrl}/api/data/getTimesheetTime` },
  updateTimesheetTime: { url: `${localUrl}/api/data/updateTimesheetTime` },
  Cyient_Accept_uid: "25",
  EmailRequest: {
    url: `${localUrl}/send-email_azure`,
  },
  email: {
    url: `${localUrl}/api/mails/MailDetails`,
  },
  DeleteDocument: {
    url: `${localUrl}/api/data/delete-file`,
  },
  react_loging: {
    react_Login_With_url: `${react_loging}`,
  },
  Redirect: {
    redirect_url: `${redirect_url}`,
  },
  Login: {
    LoginURL: `${localUrl}/api/security/Login`,
  },
  Logout: {
    url: `${localUrl}/api/security/logout`,
  },
  RefreshToken: {
    url: `${localUrl}/api/security/refreshToken`,
  },
  insertdata: {
    url: `${localUrl}/api/security/insertdata`,
  },
  Roles: {
    GetUserRolesDataUrl: `${localUrl}/index/api/getRoleBasedModules`,
    UpdateUserRolesDataUrl: `${localUrl}/index/api/updateRoleBasedModules`,
  },
  GetExistingvalue: {
    url: `${localUrl}/api/data/Existingvalue`,
  },

  jobsTemplate: {
    url: `/JS-Web/uploads/template/jobs_upload_template.xlsx`,
  },
  checklistTemplate: {
    url: `/acnc_new/uploads/template/checklist_upload_template.xlsx`,
  },
  bulkuserTemplate: {
    url: `/acnc_new/uploads/template/users_upload.xlsx`,
  },
  bulkdefectsTemplate: {
    url: `/acnc_new/uploads/template/bulkdefects_upload_template.xlsx`,
  },
  ProcessQuery: {
    url: `${localUrl}/api/data/ProcessQuery`,
  },
  ParProcessQuery: {
    url: `${localUrl}/api/data/ParProcessQuery`,
  },
  UpLoadFile: {
    url: `${localUrl}/api/uploadjobs/UploadFile`,
  },
  UpLoadAdditionalRepFields: {
    url: `${localUrl}/Xcel/WorkTrackerNxt/NodeServices/MIS/api/uploadjobs/UploadJobAdditionalFlds`,
  },
  UpLoadJobs: {
    url: `${localUrl}/api/uploadjobs/UploadJobsToDB`,
  },
  UpdateJobs: {
    url: `${localUrl}/api/data/UpdateData`,
  },
  DeleteJobs: {
    url: `${localUrl}/api/data/DeleteData`,
  },
  UpdateTimesheet: {
    url: `${localUrl}/api/data/UpdateTimesheet`,
  },
  InsertData: {
    url: `${localUrl}/api/data/InsertData`,
  },
  GetAssociatesForQCStatus: {
    url: `${localUrl}/api/data/QCAssociates`,
  },
  ProcessQueryWitVals: {
    url: `${localUrl}/api/data/ProcessQueryWithVals`,
  },
  ParProcessQueryWitVals: {
    url: `${localUrl}/api/data/ParProcessQueryWithVals`,
  },
  ParProcessQueryWitValues: {
    url: `${localUrl}/api/data/ParProcessQueryValues`,
  },
  ProcessQueryWithEmailVals: {
    url: `${localUrl}/api/data/ProcessQueryWithEmailVals`,
  },
  UpdateDatawithfunction: {
    url: `${localUrl}/api/data/UpdateDatawithfunction`,
  },
  TaskProcessQueryWithVals: {
    url: `${localUrl}/api/data/TaskProcessQueryWithVals`,
  },
  UpdateDatawithfunction1: {
    url: `${localUrl}/api/data/UpdateDatawithfunction1`,
  },
  UploadImageFile: {
    url: `${localUrl}/api/uploadjobs/Uploadimage`,
  },
  UploadJobsFromJSON: {
    url: `${localUrl}/api/uploadjobs/UploadJobsFromJSON`,
  },
  ProcessDataTableQuery: {
    url: `${localUrl}/api/data/ProcessDataTableQuery`,
  },
  ProcessQueryCursor: {
    url: `${localUrl}/api/data/ProcessQueryCursor`,
  },
  ProcessQueryCursor_test: {
    url: `${localUrl}/api/data/ProcessQueryCursor_test`,
  },

  ProcessQueryCursor2: {
    url: `${localUrl}api/data/ProcessQueryCursor2`,
  },
  getApprovedTimesheetSingle: {
    url: `${localUrl}api/data/getApprovedTimesheetSingle`,
  },
  UploadAttachment: {
    url: `${localUrl}/api/uploadjobs/saveattachments`,
  },
  ViewPar: {
    url: `${localUrl}/api/uploadjobs/SaveMapDetails`,
  },
  Savedplannedunits: {
    url: `${localUrl}/api/uploadjobs/SavePlannedUnits`,
  },
  MisUploadAttachment: {
    url: `${localUrl}/api/uploadjobs/missaveattachments`,
  },
  DownloadData: {
    url: `${localUrl}/api/data/DownloadData`,
  },
  UpLoadInvoiceJobs: {
    url: `${localUrl}/api/uploadjobs/UploadInvoice`,
  },
  GethrsDatabasedonjob: {
    url: `${localUrl}/api/data/Gethrs`,
  },
  AddRepFieldsTemplte: `/Exelon_WFM/uploads/template/`,
  UploadBlkDefectsforJobs: {
    url: `${localUrl}/api/uploadjobs/UploadBlkDefectsforJobs`,
  },
  defectsuploadTemplate: {
    url: `/Exelon_WFM/uploads/template/BulkDefectUpload.xlsx`,
  },
  ProductivityPercMax: 1000,
  DataEntryColumnOrder: `Asbuilt (Y/N),Lat,Long,ERP ID,Location/Parent Feature,Location/Parent Feature ID,Feature,Feature ID (GESW),Input Status,Tool Output Result,Final Status`,
  UploadDataEntryoutputData: {
    url: `${localUrl}/api/uploadjobs/UploadDataEntryData`,
  },
  UploadCSVFile: {
    url: `${localUrl}/api/uploadjobs/UploadCSVFile`,
  },
  UploadLocalfiles: {
    url: `${localUrl}/uploads/`,
  },
  TableColumns: {
    Viewdocuments: `document_id,document_name,document_type,document_type,activity_ref,construction_date,received_date,ehv_cable,hv_cable,lv_cable,aux,no_of_services,volume_services,plant,supports,document_path,comments,status,job_id,job_title,created_date`,
  },
  DisplayColumns: {
    Viewdocuments: `document_id,document_name,document_type,document_type,activity_ref,construction_date,received_date`,
  },
  ProcessQueryCursor_Dashboard: {
    url: `${localUrl}/api/data/ProcessQueryCursor_Dashboard`,
  },
  DownloadFile: {
    url: `${localUrl}/api/data/export-csv`,
  },
  ProcessDataTable: {
    url: `${localUrl}/api/data/ProcessDataTable`,
  },

  DownloadCSVStream: {
    url: `${localUrl}/api/data/DownloadCSVStream`,
  },
  DownloadExcelFile: {
    url: `${localUrl}/api/export/workorders`,
  },
  updateFeatureCount: {
    url: `${localUrl}/api/data/updateFeatureCount`,
  },
  checkSapOnHoldDuplicates: {
    url: `${localUrl}/api/data/checkSapOnHoldDuplicates`,
  },
  uploadSapOnHoldJobs: { url: `${localUrl}/api/data/updateSapOnHoldJobs` },
  getKpiSummary: { url: `${localUrl}/api/data/getKpiSummary` },
  uploadAdhocWorkstreams: {
    url: `${localUrl}/api/data/uploadAdhocWorkstreams`,
  },
  getAdhocWorkstreams: { url: `${localUrl}/api/data/getAdhocWorkstreams` },
  addWorkstreamRemark: { url: `${localUrl}/api/data/addWorkstreamRemark` },
  updateWorkstreamRemark: {
    url: `${localUrl}/api/data/updateWorkstreamRemark`,
  },
  getWorkstreamRemarks: { url: `${localUrl}/api/data/getWorkstreamRemarks` },
  getUserEmailByUsername: {
    url: `${localUrl}/api/data/getUserEmailByUsername`,
  },
  getSlaMissedSummary: { url: `${localUrl}/api/data/getSlaMissedSummary` },
  uploadAccrualFile: { url: `${localUrl}/api/data/uploadAccrualFile` },
  getAccrualReport: { url: `${localUrl}/api/data/getAccrualReport` },
  getScorecardDrilldown: { url: `${localUrl}/api/data/getScorecardDrilldown` },
  get_bau_weekly_received_report: {
    url: `${localUrl}/api/data/get_bau_weekly_received_report`,
  },
  get_bau_input_report_dynamic_mail: {
    url: `${localUrl}/api/data/get_bau_input_report_dynamic_mail`,
  },
  errorCodeReport: {
    uploadUrl: `${localUrl}/api/data/error-code-report/upload`,
    fetchUrl: `${localUrl}/api/data/error-code-report`,
  },

  UpdatePoSummaryDaily: {
    url: `${localUrl}/api/data/update-po-summary-daily`,
  },
  // In common/mis.js
  GetSapOnholdSummary: {
    url: `${localUrl}/api/data/getSapOnholdSummary`, // ASSUMPTION: same /api/data mount prefix as getAccrualReport
  },
  admsReportAll: {
    uploadUrl: `${localUrl}/api/data/adms-report/upload-all`,
  },
  // common/mis.js
  issueRefSummary: {
    fetchUrl: `${localUrl}/api/data/issue-ref-summary`,
  },
  admsErrorSummary: {
    fetchUrl: `${localUrl}/api/data/adms-error-summary`,
  },
};
// (d) after the closing `};` of config, before `export default config;`

// Reads the DB value; returns null on any failure so the current value is kept
export const fetchTimesheetTime = async () => {
  try {
    const res = await axios.get(config.getTimesheetTime.url);
    const v = Number(res.data?.value);
    return v === 9 || v === 12 ? v : null;
  } catch {
    return null;
  }
};

// Pulls the DB value into config.Timesheettime
export const loadTimesheetTime = async () => {
  const v = await fetchTimesheetTime();
  if (v !== null) config.Timesheettime = v;
  return config.Timesheettime;
};

// Re-sync when the user returns to this tab, so another user's change is picked up
// without a reload. ASSUMPTION: bare axios needs no token here; see the auth note below.
if (typeof window !== "undefined") {
  window.addEventListener("focus", () => {
    loadTimesheetTime();
  });
}
export default config;
